// Loaded before the router mounts. A failed settings read retains the existing
// visible presentation, including local demos without a running API.
let visible = true;

export async function loadTutorUiVisibility(): Promise<void> {
  try {
    const base = import.meta.env.VITE_API_BASE_URL ?? '';
    const response = await fetch(`${base}/v1/ui-settings`, {
      cache: 'no-store',
      signal: AbortSignal.timeout(3000),
    });
    if (!response.ok) return;
    const setting = (await response.json()) as { visible?: unknown };
    if (typeof setting.visible === 'boolean') visible = setting.visible;
  } catch {
    // Presentation setting unavailable; preserve the original UI.
  }
}

export function tutorUiVisible(): boolean {
  return visible;
}
